if (!customElements.get('memorial-plaque-personalization')) {
  customElements.define('memorial-plaque-personalization', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.form = this.closest('form'); this.input = this.querySelector('[data-plaque-photo]');
      this.canvas = this.querySelector('canvas'); this.confirm = this.querySelector('[data-plaque-confirm]');
      this.error = this.querySelector('[data-plaque-error]'); this.status = this.querySelector('[data-plaque-status]');
      this.fields = [...this.querySelectorAll('[data-plaque-text]')]; this.dialog = this.querySelector('dialog');
      const update = event => {
        this.revision = (this.revision || 0) + 1;
        if (event.target !== this.confirm) this.confirm.checked = false;
        this.validateText(); this.draw();
      };
      this.form.addEventListener('input', update, options);
      this.form.addEventListener('change', event => { update(event); if (event.target === this.input) this.loadPhoto(); }, options);
      this.querySelector('[data-plaque-remove]').addEventListener('click', () => { this.input.value = ''; this.loadPhoto(); }, options);
      this.querySelector('[data-plaque-guide]').addEventListener('click', event => this.openDialog('fonts', event.currentTarget), options);
      this.querySelector('[data-plaque-enlarge]').addEventListener('click', event => this.openDialog('preview', event.currentTarget), options);
      this.querySelector('[data-plaque-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, options);
      this.dialog.addEventListener('close', () => this.returnFocus?.focus({preventScroll:true}), options);
      this.form.addEventListener('submit', event => this.add(event), {...options,capture:true});
      this.validateText(); this.dataset.ready = 'true';
    }

    validateText() {
      const total = this.fields.reduce((sum,field) => sum + field.value.trim().length, 0);
      for (const field of this.fields) {
        const invalid = (field.required && !field.value.trim()) || field.value.length > field.maxLength;
        field.setCustomValidity(invalid ? this.dataset.textError : '');
      }
      if (total > 256) this.querySelector('[data-plaque-text="message"]').setCustomValidity(this.dataset.totalError);
      this.querySelector('[data-plaque-count]').textContent = `${total} / 256`;
    }

    async loadPhoto() {
      const version = this.version = (this.version || 0) + 1;
      this.clearPhoto(); this.confirm.checked = false; this.input.setCustomValidity(''); this.error.hidden = true;
      const file = this.input.files[0]; this.querySelector('[data-plaque-remove]').hidden = !file;
      if (!file) return;
      if (!['image/jpeg','image/png','image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024) { this.invalidPhoto(); return; }
      const url = this.photoUrl = URL.createObjectURL(file);
      this.input.setCustomValidity(this.dataset.loading); this.status.textContent = this.dataset.loading;
      try {
        const photo = new Image(); photo.src = url; await photo.decode();
        if (version !== this.version || !this.isConnected) return;
        if (!photo.naturalWidth || photo.naturalWidth * photo.naturalHeight > 80000000) throw new Error('Invalid image');
        this.photo = photo; this.input.setCustomValidity(''); this.status.textContent = file.name;
        this.querySelector('[data-plaque-photo-preview]').src = url;
        this.querySelector('[data-plaque-photo-review]').hidden = false;
        this.querySelector('[data-plaque-review]').hidden = false; this.draw();
      } catch { if (version === this.version) this.invalidPhoto(); }
    }

    clearPhoto() {
      if (this.photoUrl) URL.revokeObjectURL(this.photoUrl);
      this.photoUrl = null; this.photo = null; this.status.textContent = '';
      this.querySelector('[data-plaque-photo-preview]').removeAttribute('src');
      this.querySelector('[data-plaque-photo-review]').hidden = true; this.querySelector('[data-plaque-review]').hidden = true;
      this.querySelector('[data-plaque-full-image]').removeAttribute('src');
    }

    invalidPhoto() { this.clearPhoto(); this.input.value = ''; this.input.setCustomValidity(this.dataset.photoError); this.showError(this.dataset.photoError); }
    showError(message) { this.error.textContent = message; this.error.hidden = false; }

    draw() {
      if (!this.photo) return;
      const ctx = this.canvas.getContext('2d');
      ctx.clearRect(0,0,640,1000); ctx.fillStyle = '#eeeae2'; ctx.fillRect(0,0,640,1000);
      ctx.fillStyle = '#222622'; ctx.beginPath(); ctx.roundRect(100,60,440,880,20); ctx.fill();
      ctx.fillStyle = '#bdbfb7';
      for (const x of [130,510]) { ctx.beginPath(); ctx.arc(x,90,7,0,Math.PI*2); ctx.fill(); }
      const font = this.querySelector('[data-plaque-font]:checked');
      const variants = { '01':['bold','Arial, sans-serif'], '02':['bold','Georgia, serif'], '03':['italic','Georgia, serif'], '04':['bold','Verdana, sans-serif'], '05':['italic','Georgia, serif'], '06':['italic','Georgia, serif'], '07':['normal','Arial, sans-serif'], '08':['bold','Trebuchet MS, sans-serif'] };
      const [weight,family] = variants[font.dataset.plaqueFont];
      const value = key => this.querySelector(`[data-plaque-text="${key}"]`).value.trim();
      ctx.fillStyle = '#f6f3ea'; ctx.textAlign = 'center';
      let nameSize = 44;
      ctx.font = `${weight} ${nameSize}px ${family}`;
      while (ctx.measureText(value('name')).width > 372 && nameSize > 16) ctx.font = `${weight} ${--nameSize}px ${family}`;
      ctx.fillText(value('name'),320,180,372);
      ctx.font = '23px Georgia, serif'; if (value('dates')) ctx.fillText(value('dates'),320,224,372);
      const text = value('message').replace(/\s+/g,' ');
      const wrap = size => {
        ctx.font = `${size}px Georgia, serif`;
        const lines = [];
        for (const paragraph of text.split('\n')) {
          let line = '';
          for (const character of paragraph) {
            const next = line + character;
            if (ctx.measureText(next).width > 352 && line) {
              const split = line.lastIndexOf(' ');
              if (split > line.length/2) { lines.push(line.slice(0,split)); line = line.slice(split+1)+character; }
              else { lines.push(line); line=character; }
            } else line = next;
          }
          lines.push(line.trim());
        }
        return lines;
      };
      let size=22, lines=wrap(size);
      while (lines.length*(size*1.4)>260 && size>14) lines=wrap(--size);
      lines.forEach((line,i)=>ctx.fillText(line,320,272+i*size*1.4,352));
      const box=[150,565,340,330],scale=Math.min(box[2]/this.photo.naturalWidth,box[3]/this.photo.naturalHeight);
      ctx.drawImage(this.photo,box[0]+(box[2]-this.photo.naturalWidth*scale)/2,box[1]+(box[3]-this.photo.naturalHeight*scale)/2,this.photo.naturalWidth*scale,this.photo.naturalHeight*scale);
      const selected = this.form.querySelector('[data-product-variant]').selectedOptions[0];
      const variantName = selected.textContent.split(' · ')[0].trim();
      this.querySelector('[data-plaque-selection]').textContent = variantName;
      this.querySelector('[data-plaque-font-name]').textContent = font.value;
    }

    openDialog(view,button) {
      this.returnFocus=button;
      this.querySelector('[data-plaque-guides]').hidden=view!=='fonts';
      this.querySelector('[data-plaque-full-preview]').hidden=view!=='preview';
      this.querySelector('[data-plaque-dialog-title]').textContent=view==='fonts'?this.querySelector('[data-plaque-guide]').textContent:this.querySelector('.plaque-review h3').textContent;
      if(view==='preview')this.querySelector('[data-plaque-full-image]').src=this.canvas.toDataURL('image/png');
      this.dialog.showModal();
    }

    async add(event) {
      event.preventDefault(); event.stopImmediatePropagation();
      const submit=this.form.querySelector('[data-product-submit]'); this.validateText();
      if(this.busy || submit.disabled || !this.form.reportValidity() || !this.photo)return;
      const version=this.version,revision=this.revision,variant=this.form.querySelector('[name="id"]').value;
      const data=new FormData(this.form);
      this.fields.forEach(field=>{const value=field.value.trim();if(value)data.set(field.name,value);else data.delete(field.name);});
      this.busy=true;submit.disabled=true;this.error.hidden=true;
      const label=submit.querySelector('[data-submit-label]'),previous=label.textContent;label.textContent=submit.dataset.addingLabel;
      try {
        this.draw();
        const blob=await new Promise(resolve=>this.canvas.toBlob(resolve,'image/png'));
        if(!blob || version!==this.version || revision!==this.revision || !this.confirm.checked || variant!==this.form.querySelector('[name="id"]').value)throw new Error('Details changed');
        data.set('properties[Layout preview]',blob,'pet-memorial-plaque-layout.png');
        data.set('properties[_Font reference]',new URL(this.querySelector('[data-plaque-font]:checked').dataset.reference,location.href).href);
        const response=await fetch(new URL(this.form.action,location.origin).pathname.replace(/\/$/,'')+'.js',{method:'POST',headers:{Accept:'application/json'},body:data});
        if(!response.ok)throw new Error('Add failed');
        await response.json();document.dispatchEvent(new CustomEvent('echoes:cart-refresh',{detail:{open:true}}));
      } catch {this.showError(this.dataset.addError);}
      finally {this.busy=false;submit.disabled=this.form.querySelector('[data-product-variant]').selectedOptions[0].dataset.available!=='true';label.textContent=submit.disabled?submit.dataset.unavailableLabel:previous;}
    }

    disconnectedCallback() {this.controller?.abort();this.controller=null;this.version=(this.version||0)+1;if(this.dialog.open)this.dialog.close();if(this.photoUrl)URL.revokeObjectURL(this.photoUrl);}
  });
}
